import { Component, ojs, app, state, v } from "modular-openscriptjs";
import { uniqueId } from "../../helpers";

const h = app("h");

export default class Fab extends Component {
	isExpanded = state(false);

	render(...args) {
		let buttons = args[0];
		delete args[0];

		if (!Array.isArray(buttons)) {
			buttons = [
				h.button(
					{ class: "btn bg-white border-0 text-primary" },
					h.i({ class: "fa-solid fa-plus" }),
				),
			];
		}

		// Single button mode - show button directly
		if (buttons.length === 1) {
			const btn = buttons[0];
			btn?.classList?.add("btn-fab", "rounded-circle");

			return h._(
				h.div(
					{
						class: "fab-wrapper fixed-bottom",
						style: "bottom: env(safe-area-inset-bottom, 0);",
					},
					h.div(
						{
							class: "fab-list",
						},
						h.div(
							{
								role: "listitem",
								class: "fab-list-item",
							},
							btn,
						),
					),
					...args,
				),
			);
		}

		buttons.reverse();

		let mainId = `fb-main-${uniqueId()}`;

		// Multi-button mode - expandable radial menu
		return h.div(
			{
				class: "fab-wrapper fixed-bottom",
			},
			h.div(
				{
					class: "fab-container",
				},
				// Expanded action buttons
				v(
					this.isExpanded,
					(expanded) => {
						if (!expanded.value) return h.empty();

						return h.div(
							{
								class: "fab-actions",
							},
							buttons.map((btn, index) => {
								// Clone and add classes to avoid mutation issues
								btn.classList.add(
									"btn-fab",
									"rounded-circle",
									"fab-action",
								);

								// Stack buttons vertically above the main FAB
								const spacing = 60; // pixels between each button
								const x = -20; // same horizontal position
								let y = -(spacing * (index + 1)); // negative Y moves upward

								y -= spacing + 10;

								if (index == 0) y -= 10;
								else y -= 10;

								return h.div(
									{
										class: "fab-action-wrapper",
										style: `--x: ${x}px; --y: ${y}px; --delay: ${
											index * 50
										}ms;`,
									},
									btn,
								);
							}),
						);
					},
					{ $class: "d-block" },
				),

				// Main toggle button
				h.button(
					{
						class: "btn-fab btn-fab-main rounded-circle bg-primary text-white shadow-lg",
						onclick: this.method("toggle"),
						title: "Actions",
						id: mainId,
					},
					v(
						this.isExpanded,
						(expanded) =>
							h.i(
								{
									class: expanded.value
										? "fa-solid fa-xmark"
										: "fa-solid fa-plus",
									style: "font-size: 1.5rem; transition: transform 0.3s ease;",
									$class: "d-flex",
								},
								{ class: "d-block" },
							),
						{ $class: "d-flex" },
					),
				),
			),
			...args,
		);
	}

	toggle() {
		this.isExpanded.value = !this.isExpanded.value;
	}
}

ojs(Fab);
